/**
 * When renaming a stock item, offer to apply the same name change to other items
 * in the same category that still use the original name.
 */

export async function maybeConfirmCategoryNameBulkUpdate(
  axios,
  { matchUrl, category, oldName, newName, excludeId, entityLabel = 'items' }
) {
  const trimmedOld = (oldName || '').trim();
  const trimmedNew = (newName || '').trim();
  const trimmedCategory = (category || '').trim();

  if (!trimmedOld || !trimmedNew || trimmedOld === trimmedNew || !trimmedCategory) {
    return false;
  }

  const { data } = await axios.get(matchUrl, {
    params: {
      category: trimmedCategory,
      name: trimmedOld,
      exclude_id: excludeId,
    },
  });

  const count = data?.count || 0;
  if (count <= 0) {
    return false;
  }

  const noun = count === 1 ? 'item' : 'items';
  return window.confirm(
    `${count} other ${entityLabel} ${noun} in this category also use the name "${trimmedOld}". ` +
      `Update them to "${trimmedNew}" as well?`
  );
}

export function appendCategoryNameBulkUpdateFlag(payload, shouldUpdateMatches) {
  if (!shouldUpdateMatches) {
    return payload;
  }
  return {
    ...payload,
    update_category_name_matches: true,
  };
}

export function categoryNameUpdateSuccessMessage(baseMessage, categoryNameUpdates) {
  if (!categoryNameUpdates) {
    return baseMessage;
  }
  const count = categoryNameUpdates;
  const suffix =
    count === 1
      ? '. Also updated 1 other item in this category with the new name.'
      : `. Also updated ${count} other items in this category with the new name.`;
  return `${baseMessage}${suffix}`;
}
